export enum UserRoles {
  ANONYMOUS = 'anonymous',
  GUEST = 'guest',
  SUPPORT = 'support',
  SUBSCRIBER = 'subscriber',
}
